@if (router.url !== '/main') {

  <div class="d-flex">
    <div class="menu">
      <div class="d-flex flex-column menu-wrapper">
        <mat-list class="p0" role="list">
          <mat-list-item
            class="bg-white"
            routerLink="search" role="listitem">
            <app-logo></app-logo>
          </mat-list-item>



          <mat-list-item
            routerLinkActive="active"
            routerLink="organization" role="listitem">
            <div class="d-flex w100">
              <span class="f-gr-1" i18n>Регистрация организаций</span>
            </div>
          </mat-list-item>

          <mat-list-item
            routerLinkActive="active"
            routerLink="user-list" role="listitem">
            <span i18n>Регистрация пользователей</span>
          </mat-list-item>

          <mat-list-item
            routerLinkActive="active"
            routerLink="search" role="listitem">
            <span i18n>Список лицензии</span>
          </mat-list-item>

          <mat-list-item
            routerLinkActive="active"
            routerLink="license" role="listitem">
            <span i18n>Выдача лицензий</span>
          </mat-list-item>

          <mat-list-item
            routerLinkActive="active"
            routerLink="modules" role="listitem">
            <span i18n>Список модулей</span>
          </mat-list-item>

          <mat-list-item
            routerLinkActive="active"
            routerLink="tariffs" role="listitem">
            <span i18n>Список тарифов</span>
          </mat-list-item>

          <mat-list-item
            routerLinkActive="active"
            routerLink="billing" role="listitem">
            <span i18n>Billing</span>
          </mat-list-item>


          <mat-list-item
            routerLinkActive="active"
            routerLink="request-demo" role="listitem">
            <div class="d-flex w100">
              <span class="f-gr-1" i18n>Заявки на подключение</span>
              @if (this.demoService.countDemoRequested$ | async){
                <span class="badge">{{this.demoService.countDemoRequested$ | async}}</span>
              }

            </div>

          </mat-list-item>

          <mat-list-item
            routerLinkActive="active"
            routerLink="bug-report" role="listitem">
            <div class="d-flex w100">
              <span class="f-gr-1" i18n>Ошибки</span>
            </div>
          </mat-list-item>

          <mat-list-item
            routerLinkActive="active"
            routerLink="test-report" role="listitem">
            <div class="d-flex w100">
              <span class="f-gr-1" i18n>Результаты последних тестов</span>
            </div>
          </mat-list-item>

          <mat-list-item (click)="openSentry()"
             role="listitem">
            <div class="d-flex w100">
              <span class="f-gr-1" i18n>Sentry</span>
            </div>
          </mat-list-item>

          <mat-list-item (click)="openJenkins()"
                         role="listitem">
            <div class="d-flex w100">
              <span class="f-gr-1" i18n>Jenkins</span>
            </div>
          </mat-list-item>

          <mat-list-item (click)="openPortainer()"
                         role="listitem">
            <div class="d-flex w100">
              <span class="f-gr-1" i18n>Portainer</span>
            </div>
          </mat-list-item>

          <mat-list-item (click)="openGrafana()"
                         role="listitem">
            <div class="d-flex w100">
              <span class="f-gr-1" i18n>Grafana</span>
            </div>
          </mat-list-item>

          <mat-list-item (click)="openProxyManager()"
                         role="listitem">
            <div class="d-flex w100">
              <span class="f-gr-1" i18n>Proxy manager</span>
            </div>
          </mat-list-item>



        </mat-list>
        <div class="f-gr-1"></div>
        <div class="px16">
          <button (click)="logout()" mat-raised-button color="primary" i18n>Logout</button>
        </div>
      </div>

    </div>

    <div class="f-gr-1 overflow-auto">
      <mat-sidenav-container>
        <mat-sidenav
          class="light-content"
          [fixedInViewport]="true"
          #sidenav2 [mode]="'over'"
          position="end">
          <div class="d-flex w100 posr">
            <div class="f-gr-1"></div>
            <mat-icon class="mat-24 close pointer" (click)="sidenav2.toggle()">close</mat-icon>
          </div>
          <sous-dinamic-loader></sous-dinamic-loader>
        </mat-sidenav>
        <mat-sidenav-content [@onMainContentChange]="onSideNavChange2 ? 'open': 'close'">
          <div class="main_content">
            <div class="p32 content-wrap">
              <router-outlet></router-outlet>
            </div>
          </div>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  </div>
} @else {
  <div>
    <router-outlet></router-outlet>
  </div>
}


